__turbopack_context__.v({
  "black": "styles-module__Ussu1W__black",
  "button": "styles-module__Ussu1W__button",
  "header": "styles-module__Ussu1W__header",
  "link": "styles-module__Ussu1W__link",
  "white": "styles-module__Ussu1W__white",
});
